module.exports = __webpack_public_path__ + "img/amakabim.4a908d23.png";